import { render } from "./copy.html?vue&type=template&id=5f651792&scoped=true&ts=true"
import script from "./copy.ts?vue&type=script&lang=ts"
export * from "./copy.ts?vue&type=script&lang=ts"

import "./copy.scss?vue&type=style&index=0&id=5f651792&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f651792"]])

export default __exports__